import React, { useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Col, Divider, Form, Row } from "antd";
import NGIInput from "components/Common/inputs/NGIInput";
import Title from "antd/lib/typography/Title";
import { Option } from "antd/es/mentions";
import NGISelect from "components/Common/inputs/NGISelect";
import { PRICE_TYPES, PRICE_TYPES_OPTION, REGISTRATION_CATEGORY_LIST } from "pages/price-management/Prices/variables";
import NGIFormItem from "components/Common/form/NGIFormItem";

const useStyles = makeStyles({
  formContainer: {
    display: "flex",
    flexDirection: "column",
  },
  formItem: {
    marginTop: 15,
  },
});

const GeneralInfo = ({
  form,
  consumptionBandList,
  customerGroupList,
  validateForm,
  selectedType,
  setSelectedType,
  status,
  depotList,
}) => {
  const classes = useStyles();

  const onTypeChange = useCallback(
    value => {
      setSelectedType(value);
      validateForm();
    },
    [form]
  );
  const onDepotChange = useCallback(
    value => {
      if (value[value.length - 1] === "ALL DEPOTS" && value.length >= 1) {
        form.setFieldValue("depots", "ALL DEPOTS");
        return;
      }
      form.setFieldValue(
        "depots",
        value.filter(item => item !== "ALL DEPOTS")
      );
      validateForm();
    },
    [form]
  );

  return (
    <Form onChange={validateForm} form={form} name="generalInfo" layout="inline" className={classes.formContainer}>
      <div>
        <Row className={classes.formItem}>
          <Col span={12}>
            <Title level={5}>Price Type</Title>
            <Form.Item name="type" rules={[{ required: true, message: "Please select value" }]}>
              <NGISelect disabled={!!status} onChange={onTypeChange} showSearch placeholder="Select value">
                {PRICE_TYPES?.map(item => (
                  <Option key={item} value={item}>
                    {item}
                  </Option>
                ))}
              </NGISelect>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Title level={5}>Price Name</Title>
            <Form.Item rules={[{ required: true, message: "Please enter value" }]} name="name">
              <NGIInput disabled={status === "Active"} placeholder="Price Name" />
            </Form.Item>
          </Col>
        </Row>

        <Divider />

        {selectedType &&
          (selectedType === PRICE_TYPES_OPTION.DEPOT || selectedType === PRICE_TYPES_OPTION.CONSUMPTION_BAND) && (
            <Row className={classes.formItem}>
              <Col span={24}>
                <Title level={5}>Depots</Title>
                <NGIFormItem name="depots" rules={[{ required: true, message: "Please enter value" }]}>
                  <NGISelect
                    disabled={status === "Active"}
                    mode="multiple"
                    onChange={onDepotChange}
                    placeholder="Select value"
                  >
                    <Option value={"ALL DEPOTS"}>ALL DEPOTS</Option>
                    {depotList?.map(item => (
                      <Option key={item} value={item}>
                        {item}
                      </Option>
                    ))}
                  </NGISelect>
                </NGIFormItem>
              </Col>
            </Row>
          )}

        {selectedType &&
          selectedType !== PRICE_TYPES_OPTION.CONSUMPTION_BAND &&
          selectedType !== PRICE_TYPES_OPTION.CUSTOMER_GROUP && (
            <Row className={classes.formItem}>
              <Col span={12}>
                <Title level={5}>Registration Category</Title>
                <NGIFormItem name="registrationCategory" rules={[{ required: true, message: "Please enter value" }]}>
                  <NGISelect disabled={!!status} onChange={validateForm} placeholder="Select value">
                    {REGISTRATION_CATEGORY_LIST.map(item => (
                      <Option key={item} value={item}>
                        {item}
                      </Option>
                    ))}
                  </NGISelect>
                </NGIFormItem>
              </Col>
            </Row>
          )}
        {selectedType && selectedType === PRICE_TYPES_OPTION.CONSUMPTION_BAND && (
          <Row className={classes.formItem}>
            <Col span={12}>
              <Title level={5}>Consumption Band</Title>
              <NGIFormItem name="consumptionBand" rules={[{ required: true, message: "Please enter value" }]}>
                <NGISelect disabled={!!status} onChange={validateForm} placeholder="Select value">
                  {consumptionBandList.map(item => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </NGISelect>
              </NGIFormItem>
            </Col>
          </Row>
        )}

        {selectedType && selectedType === PRICE_TYPES_OPTION.CUSTOMER_GROUP && (
          <Row className={classes.formItem}>
            <Col span={12}>
              <Title level={5}>Customer Group</Title>
              <NGIFormItem name="customerGroup" rules={[{ required: true, message: "Please enter value" }]}>
                <NGISelect disabled={!!status} onChange={validateForm} placeholder="Select value">
                  {customerGroupList.map(item => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </NGISelect>
              </NGIFormItem>
            </Col>
          </Row>
        )}
      </div>
    </Form>
  );
};

export default GeneralInfo;
